export default "__VITE_ASSET__BQC7xbiL__"